import * as React from 'react';

import { GetFacetInputComponent } from '../FacetConfigurationMap';
import InputControlProps from './InputControlProps';
import { TreeData } from '@/common/selects/CommonTreeSelect';
import FuseSelectComponent from '@/common/selects/FuseSelect/FuseSelect';
// Using Service in this component for the cities and country caches.
// Not passing it through the parameter because it's gonna be too deep
import Service, {
  DeviceScreenFactors,
  FoodBusinessTypes,
  Operators,
  OsTypes,
  StageTypes,
} from '@/lib/App';

export interface ConstraintValueInputProps extends InputControlProps {}

export const sortTreeData = (treeData: TreeData[]) => {
  const sortedTreeData = [...treeData];
  sortedTreeData.sort((a, b) =>
    a.title.toString().localeCompare(b.title.toString()),
  );
  sortedTreeData.forEach((node) => {
    if (node.children) {
      node.children = node.children.sort((a, b) =>
        a.title.toString().localeCompare(b.title.toString()),
      );
    }
  });
  return sortedTreeData;
};

// ConstraintInputValue takes props and render the correct input box: text input, dropdown etc.
export class ConstraintValueInput extends React.Component<ConstraintValueInputProps> {
  getFacetInput = () => {
    return GetFacetInputComponent(this.props.facetName!, this.props.operator!);
  };

  makeTreeData = (facet: string, multiple: boolean = false): TreeData[] => {
    let treeData: TreeData[] = [];

    if (facet === 'city') {
      treeData = Service.cache!.getCityCountryTreeData(multiple);
    } else if (facet === 'svc') {
      let svcMap: { [key: string]: TreeData[] } = {};
      // TODO: Find a better way to store these data,, seems that the vehicles
      // contains too much data and if this is initialized every time there will
      // be performance issues with the frontend
      let vehicles = Service.cache!.getAllVehicles();

      vehicles.forEach((vehicle) => {
        if (!svcMap[vehicle.serviceType]) {
          svcMap[vehicle.serviceType] = [
            {
              key: String(vehicle.id),
              value: String(vehicle.id),
              title: vehicle.name + ' - ' + String(vehicle.id),
            },
          ];
        } else {
          svcMap[vehicle.serviceType].push({
            key: String(vehicle.id),
            value: String(vehicle.id),
            title: vehicle.name + ' - ' + String(vehicle.id),
          });
        }
      });

      for (const svcType in svcMap) {
        treeData.push({
          key: svcType,
          value: svcType,
          title: svcType,
          children: svcMap[svcType],
        });
      }
    }

    return treeData;
  };

  render() {
    const FacetInput = this.getFacetInput();
    if (this.props.facetName === 'city') {
      let treeData = this.makeTreeData(
        this.props.facetName,
        this.props.multiple,
      );
      const multiple = true;
      const sortedTreeData = sortTreeData(treeData);
      const treeNodeFilterProp = 'title';
      const tokenizable = true;
      return (
        <FacetInput
          {...{
            ...this.props,
            treeData: sortedTreeData,
            treeNodeFilterProp,
            tokenizable,
            multiple,
          }}
        />
      );
    }
    if (this.props.facetName === 'svc') {
      let keys = ['id', 'name', 'vehicleType'];
      return <FuseSelectComponent {...{ keys: keys, ...this.props }} />;
    }
    if (this.props.facetName === 'ost') {
      const availableValues = OsTypes;
      // notice that the position of availableValues in the parameters really matters to overwrite availableValues in props
      return <FacetInput {...{ ...this.props, availableValues }} />;
    }
    if (this.props.facetName === 'stage') {
      const availableValues = StageTypes;
      // notice that the position of availableValues in the parameters really matters to overwrite availableValues in props
      return <FacetInput {...{ ...this.props, availableValues }} />;
    }
    if (this.props.facetName === 'fbt') {
      const availableValues = FoodBusinessTypes;
      // notice that the position of availableValues in the parameters really matters to overwrite availableValues in props
      return <FacetInput {...{ ...this.props, availableValues }} />;
    }
    if (this.props.facetName === 'dsf') {
      const availableValues = DeviceScreenFactors;
      // notice that the position of availableValues in the parameters really matters to overwrite availableValues in props
      return <FacetInput {...{ ...this.props, availableValues }} />;
    }
    if (this.props.facetName === 'ctry') {
      const multiple = true;
      const optionFilterProp = 'children';
      const sorted = true;
      const tokenizable = true;
      return (
        <FacetInput
          {...{
            ...this.props,
            multiple,
            optionFilterProp,
            sorted,
            tokenizable,
          }}
        />
      );
    }

    if (this.props.facetName === 'dlc') {
      const multiple = true;
      return <FacetInput {...{ ...this.props, multiple }} />;
    }

    const multiple = [Operators.in, Operators['not in']].includes(
      this.props.operator,
    );
    return <FacetInput {...{ ...this.props, multiple }} />;
  }
}

export default ConstraintValueInput;
